import { render, staticRenderFns } from "./online_stock_selector.vue?vue&type=template&id=04b9db7a&scoped=true"
import script from "./online_stock_selector.vue?vue&type=script&lang=js"
export * from "./online_stock_selector.vue?vue&type=script&lang=js"
import style0 from "./online_stock_selector.vue?vue&type=style&index=0&id=04b9db7a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b9db7a",
  null
  
)

export default component.exports